import { Component, getAssetPath, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'chat-message-tips-component',
  styleUrl: 'chat-message-tips-module.scss',
  shadow: true,
})
export class ModuleChatMessageTips {
  @Prop() readonly message: IWCChatMessage;

  render() {
    return (
      <Host>
        <div class="message-tips">
          <div class="message-tips__title">
            <img
              src={getAssetPath('./../assets/icons/idea.svg')}
              alt={wcShared.translate('Icon astuce')}
            />
            <span>{wcShared?.translate('Astuce')}</span>
          </div>
          <div class="message-tips__description">
            <span innerHTML={this.message?.title}></span>
          </div>
        </div>
      </Host>
    );
  }
}
